import { makeStyles } from "@material-ui/core/styles";


const theme = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    column1: {
      padding: theme.spacing(2),
      height: "200px",
      color: theme.palette.text.secondary,
    },
    column2: {
      padding: theme.spacing(2),
  
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(2),
    },
    img: {
      alignItems: "center",
      height: "200px",
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    buttonGreen: {
      backgroundImage:
        "linear-gradient(to right, #134E5E 0%, #71B280  51%, #134E5E  100%)",
    },
    buttonRed: {
      backgroundImage:
        "linear-gradient(to right, #e52d27 0%, #b31217  51%, #e52d27  100%)",
    },
    reverButton: {
      backgroundImage:
        "linear-gradient(to right, #000428 0%, #004e92  51%, #000428  100%)",
    },
  
    pauseButton: {
      backgroundImage:
        "linear-gradient(to right, #f9c318 0%, #e7b208  50%, #826303  100%)",
    },
    buttonGray: {
      backgroundImage:
        "linear-gradient(to right, #283048 0%, #859398  51%, #283048  100%)",
    },
    ButtonCustom: {
      fontSize: "20px",
      marginRight: "10px",
      textAlign: "center",
      textTransform: "uppercase",
      transition: "0.5s",
      backgroundSize: " 200% auto",
      color: "white",
      borderRadius: "5px",
      display: "block",
      boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
      "&:hover": {
        backgroundPosition: "right center",
        color: " #fff",
        textDecoration: "none",
      },
    },
    table: {
      minWidth: 650,
    },
    container: {
      maxHeight: 500,
    },
  }));
  
  export default theme;